// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"37":"rank","112":"stockpage","179":"main","471":"exploreReport","733":"hotBlock","757":"follow","975":"iframe"}[chunkId] || chunkId) + "." + {"37":"001de81f","112":"3177f524","150":"14ff468c","179":"1a2c9a7b","471":"3488cdfc","733":"1b123abf","757":"7e55772f","975":"77e71dd5"}[chunkId] + ".js";
};